var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "AddTags",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-add-tags","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M249.5 122.2c-1.4-43.5-21.1-71-37.4-86.5-17-16.1-33.6-22.6-35.4-23.2C159.5 5 142 1.2 124.8 1.2 69.5 1.2 34.5 39.5 32.4 42 4.5 71.3-.6 104.2 0 126.6c.7 24.2 7.9 41.4 8.2 42.1v.1c34.7 76.2 99.3 80 111.9 80 1.5 0 2.4-.1 2.4-.1l1.7-.1L249.5 124v-1.8zm-16.6 5.8c-23.1 2.1-92.6 15.7-105.3 104.7l-7.1 7.1c-11 .1-71.3-3.1-104-74.7-.8-1.8-26.5-65.6 22.4-117l.1-.1c.3-.4 34-37.8 85.8-37.8 16 0 32.3 3.6 48.4 10.6l.3.1c.2.1 16.1 5.9 32.4 21.4 21.5 20.3 33.1 46.6 34.5 78.3l-7.5 7.4z"/>
  <polygon points="131,85 118,85 118,114 89,114 89,127 118,127 118,155 131,155 131,127 159,127 159,114 131,114"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/add-tags.svg